import React from 'react';
import { View } from 'react-native';
import Typography from 'src/components/Text/Text';
import Button from 'src/components/Button/Button';
import InputField from 'src/components/input/input';
import Divider from 'src/components/Divider/Divider';
import { styles } from '../screens/Insurance/InsuranceScreen.styles';

interface AmountSelectorProps {
  label: string;
  description?: string;
  presets: number[];
  value: number;
  onChange: (value: number) => void;
  testIDPrefix: string;
}

const AmountSelector: React.FC<AmountSelectorProps> = ({
  label,
  description,
  presets,
  value,
  onChange,
  testIDPrefix,
}) => {
  const isPresetSelected = presets.includes(value);

  return (
    <>
      <Divider style={styles.divider} />
      <View>
        <Typography variant="title2">{label}</Typography>
        {description && (
          <Typography variant="caption1Regular" style={styles.childLabel}>
            {description}
          </Typography>
        )}
      </View>
      <View style={styles.buttonGroupContainer}>
        {presets.map((preset) => (
          <Button
            testID={`${testIDPrefix}-${preset}`}
            key={preset}
            title={`$${preset.toLocaleString()}`}
            type={value === preset ? 'secondary' : 'tertiary'}
            onPress={() => onChange(preset)}
            style={styles.switchButton}
          />
        ))}
      </View>
      <InputField
        testID={`${testIDPrefix}-custom`}
        variant="amount"
        label={isPresetSelected ? 'Or enter custom amount' : 'Custom amount'}
        value={value > 0 ? String(value) : ''}
        onChange={(text) => {
          // If field is cleared, set to 0
          if (text === '') {
            onChange(0);
            return;
          }

          // Remove any formatting (commas, dollar signs, etc.)
          const cleanedText = text.replace(/[^0-9]/g, '');

          // Parse the cleaned numeric value
          const numeric = parseInt(cleanedText, 10);

          // Update if valid number
          if (!isNaN(numeric) && numeric >= 0) {
            onChange(numeric);
          }
        }}
      />
    </>
  );
};

export default AmountSelector;
